import { useFormContext } from 'react-hook-form';
import { GroupType, OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { OwnerModelDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import {
  AccountType,
  AccountTypeOptionsDTO,
} from '../../../../Profile/Accounts/api/useAccountsOptionsQuery';
import { OwnerTypeDTO } from '../../../../ProfileOPL/OtherAssets/OtherAssets.meta';

interface Params {
  accountTypes: AccountTypeOptionsDTO[];
  selectedAccountType: AccountType;
  accountOwners: any;
}

export const useAccountOwnership = ({
  accountTypes,
  selectedAccountType,
  accountOwners,
}: Params) => {
  const accountOptions = accountTypes.find(option => option.AccountType === selectedAccountType);

  const hasJointOptions = accountOptions?.AllowsJointOwnership;
  const hasTrustOptions = accountOptions?.AllowsTrustOwnership;
  const hasBusinessOptions = accountOptions?.AllowsBusinessOwnership;

  const getOptions = () => {
    return {
      People: hasJointOptions
        ? [...accountOwners.People]
        : accountOwners.People.filter(({ Name }) => Name !== 'Joint'),
      Trusts: hasTrustOptions && accountOwners.Trusts ? [...accountOwners.Trusts] : null,
      Businesses:
        hasBusinessOptions && accountOwners.Businesses ? [...accountOwners.Businesses] : null,
    };
  };

  const ownerOptions = getOptions();

  return {
    accountOwnersOptions: Object.keys(ownerOptions).reduce(
      (accumulator, groupKey) =>
        accumulator.concat(
          (ownerOptions[groupKey] || []).map(accountOwner => ({
            label: accountOwner.Name,
            value: accountOwner.Id,
            groupId: groupKey.toLowerCase(),
          })),
        ),
      [],
    ) as { label: string; value: string; groupId: string }[],
    accountOwnersGroups: Object.keys(ownerOptions).map(groupKey => ({
      groupId: groupKey.toLowerCase(),
      title: groupKey,
    })),
    ownerOptions: Object.keys(ownerOptions)
      .map(key => ownerOptions[key])
      .flat()
      .filter(val => val !== null) as OwnerModelDTO[],
    allowsUnequalOwnership: accountOptions ? accountOptions.AllowsUnequalOwnership : false,
  };
};
